import React from 'react';

interface LogoProps extends React.ImgHTMLAttributes<HTMLImageElement> {
  src: string;
  width?: number | string;
  variant?: 'default' | 'white-text';
  style?: React.CSSProperties;
}

const Logo: React.FC<LogoProps> = ({ src, width = 32, style, variant = 'default', ...props }) => {
  const logoStyle = { display: 'block', ...style };

  return (
    <img
      src={src}
      alt="CarbonCare Logo"
      width={width}
      style={logoStyle}
      {...props}
    />
  );
};

export default Logo;